import {useEffect, useMemo, useState} from "react";

import {IReelListItem} from "../types/IReelListItem";
import {IReelStats, useUserReelStats} from "./use_user_reel_stats";

interface IProps {
    reels?: IReelListItem[];
}

export const useReelsSortByPlays = (props: IProps, dependencies: Parameters<typeof useMemo>[1]) => {
    const [hasStatsBeenApplied, setHasStatsBeenApplied] = useState(false);
    const {getReelsPlayStats, hasInitialized: hasReelStatsBeenInitialized} = useUserReelStats();
    const [reels, setReels] = useState<IReelListItem[]>(() => sortReels(props.reels, {}));

    const refreshList = () => {
        const reelStats = getReelsPlayStats();
        setReels(sortReels(props.reels, reelStats));
    };

    useEffect(() => {
        if (hasReelStatsBeenInitialized) {
            refreshList();
            setHasStatsBeenApplied(true);
        }
    }, [hasReelStatsBeenInitialized, ...dependencies]);

    return {
        reels,
        refreshList,
        hasStatsBeenApplied
    };
};

const sortReels = (reels?: IReelListItem[], reelStats?: IReelStats) => {
    if (!reels) {
        return [];
    }

    if (reels.length < 2) {
        return [...reels];
    }

    return [...reels]?.sort((a, b) => {
        const aStats = reelStats?.[a.id] || 0;
        const bStats = reelStats?.[b.id] || 0;

        return aStats - bStats;
    });
};
import {useEffect, useMemo, useState} from "react";

import {IReelListItem} from "../types/IReelListItem";
import {IReelStats, useUserReelStats} from "./use_user_reel_stats";

interface IProps {
    reels?: IReelListItem[];
}

export const useReelsSortByPlays = (props: IProps, dependencies: Parameters<typeof useMemo>[1]) => {
    const [hasStatsBeenApplied, setHasStatsBeenApplied] = useState(false);
    const {getReelsPlayStats, hasInitialized: hasReelStatsBeenInitialized} = useUserReelStats();
    const [reels, setReels] = useState<IReelListItem[]>(() => sortReels(props.reels, {}));

    const refreshList = () => {
        const reelStats = getReelsPlayStats();
        setReels(sortReels(props.reels, reelStats));
    };

    useEffect(() => {
        if (hasReelStatsBeenInitialized) {
            refreshList();
            setHasStatsBeenApplied(true);
        }
    }, [hasReelStatsBeenInitialized, ...dependencies]);

    return {
        reels,
        refreshList,
        hasStatsBeenApplied
    };
};

const sortReels = (reels?: IReelListItem[], reelStats?: IReelStats) => {
    if (!reels) {
        return [];
    }

    if (reels.length < 2) {
        return [...reels];
    }

    return [...reels]?.sort((a, b) => {
        const aStats = reelStats?.[a.id] || 0;
        const bStats = reelStats?.[b.id] || 0;

        return aStats - bStats;
    });
};
